module.exports = __webpack_public_path__ + "static/media/200L@2x.03b17c7f.png";